import { render, staticRenderFns } from "./YellowIcon.vue?vue&type=template&id=ebd41a92"
import script from "./YellowIcon.vue?vue&type=script&lang=js"
export * from "./YellowIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports